import * as moment from 'pkp-moment-timezone-all-years';
import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .service('createProposalService', createProposalService);

    function createProposalService(storageService, capacityCategoryService) {
        var PATH_PREFIX = 'app/create-proposal/';
        var STORAGE_PREFIX = 'wizard_create-proposal_';
        var BROADCAST = {
            WIZARD_RESTART: STORAGE_PREFIX + 'restarted'
        };

        var WIZARD_ACTION = {
            DRAFT: 'SAVE',
            CREATE: 'SUBMIT'
        };

        var DETAIL_PAGE_ACTION = {
            CREATE_RESPONSE: 'CREATE_RESPONSE'
        };

        var INTENTION = {
            SELL: 'PROPOSAL_TO_SELL',
            BUY: 'PROPOSAL_TO_BUY'
        };

        var PROCEDURE = {
            OTC: 'OTC',
            FCFS: 'FCFS',
            CFO: 'CFO'
        };

        var TRANSACTION_TYPE = {
            ASSIGNMENT: 'ASSIGNMENT',
            TRANSFER: 'TRANSFER_OF_USE'
        };

        var CAPACITY_SOURCE = {
            PRIMARY_DEAL_ID: 'PRIMARY_DEAL_ID',
            SECONDARY_TRADE_ID: 'SECONDARY_TRADE_ID',
            EXTERNAL_DEAL: 'EXTERNAL_DEAL',
            MANUAL_INPUT: 'MANUAL_INPUT'
        };

        var CAPACITY_UNIT = {
            KWH_H: 'kWh/h',
            KWH_D: 'kWh/d',
            M3_H: 'Cm³/h'
        };

        var stages = {
            1: {
                title: 'Select network point',
                page: PATH_PREFIX + 'create-proposal-stage-one.html'
            },
            2: {
                title: 'Choose Type',
                page: PATH_PREFIX + 'create-proposal-stage-two.html'
            },
            3: {
                title: 'Create trading details',
                page: PATH_PREFIX + 'create-proposal-stage-three.html'
            },
            4: {
                title: 'Enter capacity details',
                page: PATH_PREFIX + 'create-proposal-stage-four.html'
            },
            5: {
                title: 'Confirm',
                page: PATH_PREFIX + 'create-proposal-stage-five.html'
            }
        };

        var pages = {
            inputSummary: PATH_PREFIX + 'create-proposal-input-summary.html'
        };

        var capacityUnits = {
            KWH_H: 'kWh/h',
            KWH_D: 'kWh/d',
            M3_H: 'Cm³/h'
        };

        var minLotRuntimeUnits = {
            DAY: 'DAY',
            HOUR: 'HOUR',
            MONTH: 'MONTH'
        };

        //If Wizard is called from dashboard
        var networkPoint;

        return {
            STORAGE_PREFIX: STORAGE_PREFIX,
            BROADCAST: BROADCAST,
            WIZARD_ACTION: WIZARD_ACTION,
            DETAIL_PAGE_ACTION: DETAIL_PAGE_ACTION,
            INTENTION: INTENTION,
            PROCEDURE: PROCEDURE,
            TRANSACTION_TYPE: TRANSACTION_TYPE,
            CAPACITY_SOURCE: CAPACITY_SOURCE,
            CAPACITY_UNIT: CAPACITY_UNIT,
            stages: stages,
            pages: pages,
            capacityUnits: capacityUnits,
            minLotRuntimeUnits: minLotRuntimeUnits,
            buildTsoConfig: buildTsoConfig,
            buildOptions: buildOptions,
            millis: millis,
            evaluteError: evaluteError,
            fromDateTime: fromDateTime,
            toDateTime: toDateTime,
            toMoment: toMoment,
            getEic: getEic,
            mapUnderlyingDealSources: mapUnderlyingDealSources,
            reset: reset,
            getAllStages: getAllStages,
            getStageOne: getStageOne,
            setStageOne: setStageOne,
            getStageTwo: getStageTwo,
            setStageTwo: setStageTwo,
            getStageThree: getStageThree,
            setStageThree: setStageThree,
            getStageFour: getStageFour,
            setStageFour: setStageFour,
            getStageFive: getStageFive,
            setStageFive: setStageFive,
            setEditStage: setEditStage,
            getSuccess: getSuccess,
            setSuccess: setSuccess,
            setNetworkPoint: setNetworkPoint,
            getNetworkPoint: getNetworkPoint,
            isCompleteRuntime: isCompleteRuntime
        };

        function buildTsoConfig(index, tsoConfig, balancingCodeInfo) {
            var result: any = {
                priceUnit: tsoConfig.priceUnit,
                priceUnitLabel: !angular.isUndefined(tsoConfig.priceUnit)
                    ? tsoConfig.priceUnit.label
                    : '',
                gtcUrl: tsoConfig.gtcUrl,
                leadTimeInfo: tsoConfig.leadTimeInfo,
                tsoShipperNote: tsoConfig.tsoShipperNote,
                creditLimitCheckEnabled: tsoConfig.creditLimitCheckEnabled,
                transferOfUseBalancingGroupPrevention:
                    tsoConfig.transferOfUseBalancingGroupPrevention,

                updateRegulatedTariffAllowed: isSupported(
                    tsoConfig.updateRegulatedTariff
                ),
                prefillPrice: isSupported(tsoConfig.prefillUnderlyingPrice),
                capturePriceManually: isSupported(
                    tsoConfig.captureUnderlyingPriceManually
                ),
                applyRegulatedTariff: isSupported(
                    tsoConfig.checkboxRegulatedTariff
                ),

                surchargeForManualRequired: isMandatory(
                    tsoConfig.underlyingSurchargeForManual
                ),
                underlyingDealRequired: isMandatory(
                    tsoConfig.underlyingDealConfig
                ),
                surchargeForManualDesired: !isNotApplicable(
                    tsoConfig.underlyingSurchargeForManual
                ),
                underlyingDealDesired: !isNotApplicable(
                    tsoConfig.underlyingDealConfig
                )
            };
            if (!angular.isUndefined(balancingCodeInfo)) {
                result.balancingGroupRequired = isMandatory(
                    balancingCodeInfo['balancingGroupConfig' + index]
                );
                result.portfolioCodeRequired = isMandatory(
                    balancingCodeInfo['portfolioCodeConfig' + index]
                );
                result.balancingGroupDesired = !isNotApplicable(
                    balancingCodeInfo['balancingGroupConfig' + index]
                );
                result.portfolioCodeDesired = !isNotApplicable(
                    balancingCodeInfo['portfolioCodeConfig' + index]
                );
            }
            return result;
        }

        function buildOptions(
            index,
            tsoConfig,
            balancingCodeInfo,
            networkPoint
        ) {
            var result: any = {
                capacitySources: mapUnderlyingDealSources(
                    tsoConfig.supportedUnderlyingDealSources
                ),
                capacityCategories:
                    capacityCategoryService.translateCapacityCategories(
                        networkPoint['capacityCategories' + index]
                    )
            };
            if (!angular.isUndefined(balancingCodeInfo)) {
                result.balancingGroups =
                    balancingCodeInfo['balancingGroups' + index];
                result.portfolioCodes =
                    balancingCodeInfo['portfolioCodes' + index];
            }
            return result;
        }

        function isSupported(config) {
            return config === 'SUPPORTED';
        }

        function isMandatory(config) {
            return config === 'MANDATORY';
        }

        function isNotApplicable(config) {
            return config === 'NOT_APPLICABLE';
        }

        function millis(date) {
            var ms = Date.parse(date);
            if (isNaN(ms)) {
                return null;
            }
            return ms;
        }

        function evaluteError(isValid, formElement, msg) {
            if (!angular.isUndefined(formElement)) {
                if (isValid) {
                    formElement.$setValidity(msg, true);
                } else {
                    formElement.$setValidity(msg, false);
                }
            }
        }

        function toDateTime(obj) {
            if (
                !angular.isUndefined(obj.date) &&
                !angular.isUndefined(obj.time)
            ) {
                var time = obj.time.split(':');
                var date = new Date(obj.date);
                date.setHours(time[0], time[1], 0);
                return moment(date).toDate();
            }
        }

        function toMoment(obj) {
            if (
                !angular.isUndefined(obj.date) &&
                !angular.isUndefined(obj.time)
            ) {
                var time = obj.time.split(':');
                var date = new Date(obj.date);
                date.setHours(time[0], time[1], 0);
                return moment(date);
            }
        }

        function fromDateTime(obj) {
            return {
                date: moment(obj).format('YYYY-MM-DD'),
                time: moment(obj).format('HH:mm')
            };
        }

        function getEic(shipper) {
            if (
                !angular.isUndefined(shipper) &&
                !angular.isUndefined(shipper.identifierList)
            ) {
                for (var i = 0; i < shipper.identifierList.length; i++) {
                    if (shipper.identifierList[i].type === 'EIC') {
                        return shipper.identifierList[i].id;
                    }
                }
            }
        }

        function mapUnderlyingDealSources(sources) {
            var mapped = [];

            for (var i = 0; i < sources.length; i++) {
                var source: any = {
                    value: sources[i]
                };

                switch (sources[i]) {
                    case CAPACITY_SOURCE.PRIMARY_DEAL_ID: {
                        source.label = 'Primary deal concluded on PRISMA';
                        break;
                    }
                    case CAPACITY_SOURCE.SECONDARY_TRADE_ID: {
                        source.label = 'Secondary trade concluded on PRISMA';
                        break;
                    }
                    case CAPACITY_SOURCE.EXTERNAL_DEAL: {
                        source.label =
                            'External deal (contract uploaded by the TSO)';
                        break;
                    }
                    case CAPACITY_SOURCE.MANUAL_INPUT: {
                        source.label =
                            'Manually enter the capacity information';
                        break;
                    }
                }

                mapped.push(source);
            }

            return mapped;
        }

        /**
         *
         * @param {Runtime} runtime
         * @param {app.MinimumLotRuntime} minLotRuntime
         * @returns {boolean}
         */
        function isCompleteRuntime(runtime, minLotRuntime) {
            if (!minLotRuntime) {
                return true;
            }

            var runtimeDuration = moment(runtime.end).diff(
                runtime.start,
                minLotRuntime.type.toLowerCase() + 's'
            );
            return runtimeDuration === minLotRuntime.value;
        }

        function reset() {
            deleteAll();
        }

        function getAllStages() {
            return {
                stageOne: getStageOne(),
                stageTwo: getStageTwo(),
                stageThree: getStageThree(),
                stageFour: getStageFour(),
                stageFive: getStageFive()
            };
        }

        function getStageOne() {
            return parseData(fetch('stageOne'));
        }

        function setStageOne(data) {
            store('stageOne', data);
        }

        function getStageTwo() {
            return parseData(fetch('stageTwo'));
        }

        function setStageTwo(data) {
            store('stageTwo', data);
        }

        function getStageThree() {
            return parseData(fetch('stageThree'));
        }

        function setStageThree(data) {
            store('stageThree', data);
        }

        function getStageFour() {
            return parseData(fetch('stageFour'));
        }

        function setStageFour(data) {
            store('stageFour', data);
        }

        function getStageFive() {
            return parseData(fetch('stageFive'));
        }

        function setStageFive(data) {
            store('stageFive', data);
        }

        /**
         * this method manipulates an storage variable defined and used by wizard directive
         * TODO may there should be a wizard service providing this method also for other wizards
         */
        function setEditStage() {
            store('farthestStageIndex', 5);
        }

        function getSuccess() {
            return parseData(fetch('success'));
        }

        function setSuccess(data) {
            store('success', data);
        }

        function store(key, value) {
            storageService.storeToSession(parseKey(key), value);
        }

        function fetch(key) {
            return storageService.fetchFromSession(parseKey(key));
        }

        function deleteAll() {
            storageService.removeFromSessionWithPrefix(STORAGE_PREFIX);
        }

        function parseKey(key) {
            return STORAGE_PREFIX + key;
        }

        function parseData(stage) {
            return stage ? stage : {};
        }

        function setNetworkPoint(netPoint) {
            networkPoint = netPoint;
        }

        function getNetworkPoint() {
            return networkPoint;
        }
    }
})();
